import { useContext } from 'react'
import { ProgressBar } from './createProgressBar'
import { ProgressBarContext } from './ProgressBarContext'

export function useProgressBar(): ProgressBar {
  return useContext(ProgressBarContext)
}
